import { ForwardedRef, forwardRef } from "react";
import { IButtonProps } from "./Button.types";

export type { IButtonProps };
const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, IButtonProps>(
  (props, ref) => {
    const {
      className,
      href,
      onClick,
      children,
      outline,
      transparent,
      size,
      icon,
      fullWidth,
      color,
      ...restProps
    } = props;
    const themeColor = color ? color : "primary";

    const classNames = `btn btn-${outline ? "outline-" : ""}${themeColor}${
      transparent ? " btn--transparent" : ""
    }${size ? ` btn--${size}` : ""}${icon ? ` btn--icon` : ""}${
      fullWidth ? ` w-100` : ""
    }${className ? ` ${className}` : ""}`;

    if (href) {
      return (
        <a
          className={classNames}
          href={props.href}
          ref={ref as ForwardedRef<HTMLAnchorElement>}
          {...restProps}
        >
          {children}
        </a>
      );
    }
    return (
      <button
        onClick={onClick ? onClick : () => {}}
        className={classNames}
        ref={ref as ForwardedRef<HTMLButtonElement>}
        {...restProps}
      >
        {children}
      </button>
    );
  },
);

export default Button;
